<template>
  <div class="privacy bg-layout">
    <div id="content">
      <div>
        更新日期：2019年7月19日<br>
        生效日期：2019年7月19日
      </div>
      <br>
      <p>
        广州大壁虎科技有限公司（以下简称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。鉴此，我们制定本《恋爱物语隐私权政策》（下称“本政策
        /本隐私权政策”）并提醒您：</p>
      <p>本政策适用于恋爱物语产品或服务，需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于恋爱物语中已另行独立设置隐私权政策的产品或服务。
        在使用恋爱物语各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用恋爱物语各项产品或服务，即表示您已充分理解并同意本政策。若对本政策内容有任何疑问、意见或建议，您可通过恋爱物语提供的各种联系方式与我们联系。</p>
      <br>

      <h4>本隐私权政策部分将帮助您了解以下内容：</h4>
      <div>
        1、我们如何收集您的个人信息<br>
        2、我们如何分享、转让、公开披露您的个人信息<br>
        3、我们如何保护您的个人信息<br>
        4、您如何管理您的个人信息<br>
        5、未成年保护<br>
        6、本隐私权政策如何更新<br>
        7、如何联系我们<br>
      </div>
      <br>
      <h4>一、我们如何收集您的个人信息</h4>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，我们会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
      <br>
      <h4>（一）帮助您成为我们的用户</h4>
      <p>为完成创建账号，以便我们为您提供服务，您需要提供以下信息：您的昵称、头像、性别、出生年月日、手机号码/恋爱物语号/QQ号。</p>
      <p>您提供的上述信息将在您使用本服务期间持续授权我们使用。在账号注销时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。</p>
      <br>
      <h4>（二）向您提供商品或服务</h4>
      <div>1、您向我们提供的信息</div>
      <p>您在注册账户或使用我们的服务时，向我们提供的相关个人信息，包括<span class="b">电话号码、电子邮件、银行卡号或支付宝账号></span>；</p>
      <p>您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。向恋爱物语提供该其他方的前述个人信息之前，您需确保您已经取得其授权同意。</p>
      <br>
      <div>2、我们在您使用服务过程中收集的信息</div>
      <p>
        在你使用恋爱物语服务的过程中，恋爱物语会收集关于你在使用服务时主动提供或因为使用服务而产生的信息并将这些信息进行关联，用以向你提供服务、优化我们的服务、保障你的帐号安全、识别账号异常状态、了解产品适配性，我们将按照如下方式收集：</p>
      <br>
      <div>
        1.1 当你注册恋爱物语服务时，我们会收集你的昵称、头像、<span class="b">手机号码</span>、地区，收集这些信息是为了帮助你完成恋爱物语注册，保护你恋爱物语帐号的安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若你不提供这类信息，你可能无法正常使用我们的服务。你还可以根据自身需求选择填写性别信息。<br><br>
        1.2 当你使用恋爱物语服务时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，我们会收集你的<span class="b">设备型号、使用的语言、操作系统、唯一设备标识符、登陆IP地址、浏览器类型</span>，恋爱物语软件版本号、<span class="b">接入网络的方式、类型和状态</span>、网络质量数据、设备加速器（重力感应设备）、<span class="b">操作日志、服务日志信息</span>（包括你在恋爱物语搜索、查看的信息、访问时间、服务故障信息、引荐网址信息及您访问的网页记录）此类日志信息，这类信息是为提供服务必须收集的基础信息。其中设备信息、日志信息如下：<br><br>
        1.2.1 <span class="b">设备信息</span>：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括软硬件特征信息：<span class="b">设备型号、操作系统版本、设备设置、唯一设备标识符</span>）、<span class="b">设备所在位置</span>相关信息（包括<span class="b">IP 地址、GPS位置</span>以及能够提供相关信息的<span class="b">Wi-Fi 接入点、蓝牙</span>和<span class="b">基站传感器</span>信息，因我们提供的服务系基于地理位置提供的移动社交服务，您确认成功注册“恋爱物语”帐号视为确认授权我们提取、公开及使用您的<span class="b">地理位置信息</span>。如您需要终止向其他用户公开其地理位置信息，可随时自行设置为隐身状态）。<br><br>
        请注意，单独的设备信息、日志信息无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
        当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。<br><br>
        1.2.2 <span class="b">日志信息</span>：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。包括您的搜索查询内容、IP地址、电信运营商、使用的语言、访问日期和时间及您访问的网页记录。<br><br>
        1.3 当你使用恋爱物语动态功能时，你上传的<span class="b">照片、评论、点赞</span>信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，你也可以随时删除这些信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述动态信息，或者将其用于该功能以外的其他用途。<br><br>
        1.4 当你使用恋爱物语搜索功能时，我们会收集你的<span class="b">搜索记录、阅读记录和访问时间、评论</span>和<span class="b">互动记录</span>，目的是为了向你提供更加精准和个性化的服务和内容。<br><br>
        1.5 当你使用恋爱物语与其他软件或硬件互通功能时，其他软件或硬件的提供方在经你同意后可以获取你在恋爱物语主动公开或传输的相关信息，你在选择前应充分了解其他软件或硬件的产品功能及信息保护策略。<br><br>
        1.6 当你使用恋爱物语视频功能时，你上传的<span class="b">视频、评论、互动</span>信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，你也可以随时删除自己上传的视频。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用于该功能以外的其他用途。<br><br>
        1.7 恋爱物语服务中的第三方服务由外部第三方主体提供，恋爱物语无法获得你在使用该类第三方服务时产生的信息。但是，如果你已明示同意该第三方获得你的<span class="b">地理位置信息</span>，该第三方将通过恋爱物语接口获得你的终端地理位置信息。该信息属于敏感信息，拒绝提供该信息仅会使你无法使用上述第三方服务，但不影响你正常使用恋爱物语的功能。<br><br>
      </div>
      <br>
      <p>另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用你的相关个人信息无需征求你的授权同意：</p>
      <br>
      <div>
        1) 与国家安全、国防安全国家利益直接相关的；与公共安全、公共卫生、公众知情这类重大公共利益直接相关的；<br>
        2) 与犯罪侦查、起诉、审判和判决执行等直接相关的；<br>
        3) 出于维护你或其他个人的生命、财产、声誉重大合法权益但又很难得到本人同意的；<br>
        4) 所收集的个人信息是你自行向社会公众公开的；<br>
        5) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道；<br>
        6) 根据你要求签订和履行合同所必需的；<br>
        7) 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br>
        8) 为开展合法的新闻报道所必需的；<br>
        9) 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
        10) 法律法规规定的其他情形。
      </div>
      <br>
      <p>请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了你的信息，我们会通过页面提示、交互流程、网站公告方式另行向你说明信息收集的内容、范围和目的，以征得你的同意。</p>
      <p>
        请你注意，目前恋爱物语不会主动从第三方获取你的个人信息。如未来为业务发展需要从第三方间接获取你个人信息，我们会在获取前向你明示你个人信息的来源、类型及使用范围，如恋爱物语开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。</p>
      <br>
      <h4>（三）信息的存储及为您提供的安全保障</h4>
      <div>
        <br>
        1.信息存储的地点<br>
        我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。<br>
        <br>
        2.信息存储的期限<br>
        一般而言，我们仅为实现目的所必需的时间保留你的个人信息，包括：<br><br>
        手机号码：若你需要使用恋爱物语服务，我们需要一直保存你的手机号码，以保证你正常使用该服务，当你注销帐户后，我们将删除相应的信息；<br>
        动态信息：当你发送了动态，我们需要保存你的动态信息，以保证你正常使用动态功能，当你删除你的动态信息后，我们将删除相应的信息。<br>
        当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。<br>
        <br>
        3.为您提供的安全保障<br>
        为提高您使用我们公司服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入，更准确地识别违反法律法规或恋爱物语相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。<br>
      </div>
      <br>
      <h4>（四）我们如何使用您的信息</h4>
      <p>
        我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告（你可以在关于广告页面中了解更多）、对你阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容。</p>
      <p>
        为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。</p>
      <p>如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。</p>
      <p>我们将信息用于本政策未载明的其他用途、或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</p>
      <br>
      <h4>（五）征得授权同意的例外</h4>
      <p>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p><br>
      <div>
        1、与国家安全、国防安全有关的；<br>
        2、与公共安全、公共卫生、重大公共利益有关的；<br>
        3、与犯罪侦查、起诉、审判和判决执行有关的；<br>
        4、出于维护个人信息主体或其他个人的生命、财产此类重大合法权益但又很难得到您本人同意的；<br>
        5、所收集的个人信息是您自行向社会公众公开的；<br>
        6、从合法公开披露的信息中收集个人信息的，包括合法的新闻报道、政府信息公开渠道；<br>
        7、根据您的要求签订合同所必需的；<br>
        8、用于维护所提供的产品或服务的安全稳定运行所必需的；<br>
        9、为合法的新闻报道所必需的；<br>
        10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
        11、法律法规规定的其他情形。<br>
      </div>
      <br>
      <p>如我们停止运营恋爱物语产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
      <br>
      <h4>（六）我们如何使用Cookie和同类技术</h4>
      <p>
        Cookie是支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制。当你在使用部分功能的时候，我们会向你的设备发送一个或多个Cookie或匿名标识符。当你与这些功能产生交互时，我们允许Cookie或者匿名标识符发送给恋爱物语服务器。Cookie
        通常包含一些随机生成的字符。运用Cookie技术，恋爱物语能够了解你的使用习惯，或帮你判断你账户的安全性。Cookie还可以帮助我们统计流量信息，分析页面设计的有效性。</p>
      <p>我们不会将 Cookie 用于本政策所述目的之外的任何用途。你可根据自己的偏好管理或删除 Cookie。</p>
      <h4>二、我们如何分享、转让、公开披露您的个人信息</h4>
      <h4>（一）分享</h4>
      <p>我们不会与恋爱物语服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p><br>
      <div>
        1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。<br>
        2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。<br>
        3、与关联公司间共享：为便于我们基于关联账号共同向您提供服务，推荐您可能感兴趣的信息或保护恋爱物语关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用恋爱物语账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。<br>
      </div>
      <br>
      <h4>（二）转让</h4>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p><br>
      <div>
        1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；<br>
        2、在涉及合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会提前告知您上述情形，并要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。<br>
      </div>
      <br>
      <h4>（三）公开披露</h4>
      <p>我们仅会在以下情况下，公开披露您的个人信息：</p><br>
      <div>
        1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；<br>
        2、如果我们确定您出现违反法律法规或严重违反恋爱物语相关协议规则的情况，或为保护恋爱物语及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或恋爱物语相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及恋爱物语已对您采取的措施。<br>
        <div>
          <br>
          <h4>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</h4>
          <p>以下情形中，分享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p><br>
          <div>
            1、与国家安全、国防安全有关的；<br>
            2、与公共安全、公共卫生、重大公共利益有关的；<br>
            3、与犯罪侦查、起诉、审判和判决执行有关的；<br>
            4、出于维护您或其他个人的生命、财产此类重大合法权益但又很难得到本人同意的；<br>
            5、您自行向社会公众公开的个人信息；<br>
            6、从合法公开披露的信息中收集个人信息的，包括合法的新闻报道、政府信息公开。<br>
          </div>
          <br>
          <p>
            根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
          <br>
          <h4>三、我们如何保护您的个人信息安全</h4>
          <p>（一）我们已采取符合业界通用解决方案、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。包括您的浏览器与服务器之间交换重要数据时受
            SSL（Secure Socket
            Layer）协议加密保护；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；</p>
          <p>（二）我们还将不断学习和采用行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术方面多维度提升整个系统的安全性。</p>
          <p>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
          <p>
            （四）互联网并非绝对安全的环境，我们强烈建议您不要使用非恋爱物语推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容相关信息的第三方。
            如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络恋爱物语客服，以便我们根据您的申请采取相应措施。
            请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发表动态或者在群聊天、圈子此类公众场合选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
            请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。 同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
          <br>
          <h4>四、您如何管理您的个人信息</h4>
          <p>您可以通过以下方式访问及管理您的个人信息：</p><br>
          <h4>（一）访问您的个人信息</h4>
          <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p><br>
          <div>
            ①访问头像、昵称、ID号、年龄、性别、地区、个性签名、历史动态：<br>
            1）进入恋爱物语后，点击“我的”；<br>
            2）点击头像栏；<br>
            3）进行信息查询访问或更改、删除。<br>
          </div>
          <br>
          <div>
            ②访问或删除手机号、账号密码、app个性化设置信息：<br>
            1）进入恋爱物语后，点击“我的”；<br>
            2）点击右上角“设置”；<br>
            3）进行信息查询访问或更改。<br>
          </div>
          <br>
          <div>
            ③访问您的app消息设置、房间设置：<br>
            1）进入恋爱物语后，点击“我的”；<br>
            2）点击右上角“设置”；<br>
            3）点击“消息通知设置”、“房间设置”进行设置查询访问或更改。<br>
          </div>
          <br>
          <div>
            ④访问您黑名单设置：<br>
            1）进入恋爱物语后，点击“我的”；<br>
            2）点击右上角“设置”；<br>
            点击“黑名单”进行查询访问或更改、删除。<br>
          </div>
          <p>如果您无法通过上述路径访问个人信息，您可以随时通过恋爱物语客服与我们取得联系。我们将在30天内回复您的访问请求。</p><br>

          <h4>（二）更正或补充您的个人信息</h4>
          <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条“（一）访问您的个人信息”中列明的方式提出更正或补充申请</p><br>
          <h4>（三）删除您的个人信息</h4>
          <p>您可以通过本条“（一）访问您的个人信息”中列明的方式访问及删除您的个人信息。</p>
          <p>在以下情形中，您可以通过联系我们客服提出删除个人信息的请求：</p>
          <div>1、如果我们处理个人信息的行为违反法律法规；</div>
          <div> 2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</div>
          <div>3、如果我们处理个人信息的行为严重违反了与您的约定；</div>
          <div>4、如果您不再使用我们的产品或服务，或您主动注销了账号；</div>
          <div>5、如果我们永久不再为您提供产品或服务。</div>
          <br>
          <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
          <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
          <br>
          <h4>（四）改变您授权同意的范围</h4>
          <p>每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“第一条”）。除此之外，对于额外个人信息的收集和使用，您可以在我的-意见反馈中与恋爱物语客服联系给予或收回您的授权同意。
            当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
          <br>
          <h4>（五）响应您的上述请求</h4>
          <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。 我们将在30天内做出答复。如您不满意，还可以通过恋爱物语客服发起投诉。
            对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（包括需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
          <p>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
          <br>
          <div>1、与国家安全、国防安全有关的；</div>
          <div>2、与公共安全、公共卫生、重大公共利益有关的；</div>
          <div>3、与犯罪侦查、起诉、审判和执行判决有关的；</div>
          <div>4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</div>
          <div>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</div>
          <div>6、涉及商业秘密的。</div>
          <br>
          <h4>五、未成年人保护</h4>
          <p>
            我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是14周岁以下的未成年人，在使用恋爱物语前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过联系我们中的联系方式与我们联系。</p>
          <h4>六、本隐私权政策如何更新</h4>
          <p>我们的隐私权政策可能变更。</p>
          <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。对于重大变更，我们会提前显著的通知（包括我们会通过恋爱物语公示的方式进行通知甚至向您提供弹窗提示），并持续公示10个工作日。</p>
          <p>本政策所指的重大变更包括但不限于：</p><br>
          <div>1、我们的服务模式发生重大变化。包括处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</div>
          <div>2、我们在控制权方面发生重大变化。包括并购重组引起的所有者变更；</div>
          <div>3、个人信息共享、转让或公开披露的主要对象发生变化；</div>
          <div>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
          <div>5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
          <div>6、个人信息安全影响评估报告表明存在高风险时。</div>
          <br>
          <p>我们还会将本隐私权政策的旧版本存档，供您查阅。</p>
          <br>
          <h4>七、如何联系我们</h4>
          <div>您可以通过以下方式与我们联系，我们将在15天内回复您的请求：</div>
          <br>
          <div>1、如对本政策内容有任何疑问、意见或建议，您可通过恋爱物语手机APP中“我的”-“意见反馈”中与我们联系；</div>
          <div>2、如发现个人信息可能被泄露，您可以通过0755-26973501投诉举报；</div>
          <br>
          <div>我们将尽快审核所涉问题，并在验证你的用户身份后的15天内予以回复。</div>
          <div>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。</div>
          <br>
          <div>公司名称：广州大壁虎科技有限公司</div>
          <div>注册地址：广州市黄埔区科学大道182号C1栋1004单元青年之家创新创业孵化基地众创空间办公卡位E027</div>
          <div>个人信息保护负责人联系邮箱：296832328@qq.com</div>
          <br>
          <div>当你有其他的投诉、建议、未成年人个人信息相关问题时，请通过 http://www.tiduhn.cn/与我们联系。你也可以将你的问题发送至QQ:800800664或寄到如下地址：</div>
          <br>
          <div>广州市黄埔区科学大道182号C1栋1004单元青年之家创新创业孵化基地众创空间办公卡位E027</div>
          <div>大壁虎科网络（收）</div>
          <div>邮编：510000</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PrivacyVoice',
  data () {
    return {}
  },
  created () {
    this.$store.commit('inWhichPage', { page: 'privacy_voice' });
  },
  computed: {
    status () {
      console.log(this.$store.state.status);
      return this.$store.state.status;
    }
  },
}
</script>
<style scoped>
.privacy {
  text-align: left !important;
}
.tc {
  text-align: center;
  padding: 10px;
}

p {
  text-indent: 2em;
  padding: 5px 0px;
}

#content {
  font-size: 14px;
  line-height: 150%;
  padding: 0 10px;
}

.bg-layout {
  background-size: 100% 100%;
  position: absolute;
  z-index: -1;
  color: #171623;
  font-family: "微软雅黑";
}

.b {
  font-weight: 700;
  color: #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/mobilPage/privacy_qbt.vue